// Centralized predicate for "this case counts as Stopped".
// May 31, 2026 — applied across QC / HR / Agency / DataEntry / Admin dashboards
// so every list and count of "Stopped Cases" stays in sync.
//
// A case is considered Stopped if:
//   1. case.status === 'stopped' (the canonical case-level value), OR
//   2. case.status === 'stop_check' (legacy case-level value used by
//      older stop endpoints), OR
//   3. any child check has status === 'stop_check' (per-check stops
//      where the case itself is still 'in_progress' or 'completed')
//
// Production has cases in all three shapes — earlier filters that
// only matched (1) reported 0 stopped cases despite many existing.

export const isStoppedCase = (caseItem) => {
  if (!caseItem) return false;
  if (caseItem.status === 'stopped' || caseItem.status === 'stop_check') return true;
  if (Array.isArray(caseItem.checks)) {
    return caseItem.checks.some((chk) => chk && chk.status === 'stop_check');
  }
  return false;
};
